module.exports = __webpack_public_path__ + "static/media/demand-active.a4dae6c5.svg";